import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const BeltedCombatLeatherPants = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.pants.BeltedCombatLeatherPants.itemName}
      name={AW23.pants.BeltedCombatLeatherPants.itemName}
      price={AW23.pants.BeltedCombatLeatherPants.itemPrice}
      fabric={AW23.pants.BeltedCombatLeatherPants.itemFabric}
      src={AW23.pants.BeltedCombatLeatherPants.sizeChart}
      divId={AW23.pants.BeltedCombatLeatherPants.shopifyDivId}
      mainId={AW23.pants.BeltedCombatLeatherPants.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.pants.BeltedCombatLeatherPants.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.pants.BeltedCombatLeatherPants.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default BeltedCombatLeatherPants;
